/** Shared timeline for animation + future physics scrub. */
export class Clock {
  time = 0;
  duration = 0;
  playing = false;
  loop = true;
  speed = 1;

  tick(dt: number): void {
    if (!this.playing) return;
    this.time += dt * this.speed;
    if (this.duration > 0 && this.time > this.duration) {
      this.time = this.loop ? 0 : this.duration;
      if (!this.loop) this.playing = false;
    }
  }

  seek(t: number): void {
    this.time = Math.max(0, this.duration > 0 ? Math.min(t, this.duration) : t);
  }
}

/** Master timeline + per-layer offset, clamped to a clip length. */
export function layerClockTime(masterTime: number, offset: number, clipDuration: number): number {
  const t = masterTime + offset;
  if (clipDuration > 0) return Math.min(Math.max(0, t), clipDuration);
  return Math.max(0, t);
}
